import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import {
    Button,
    Checkbox,
    FormControlLabel,
    Input,
    LinearProgress,
    MenuItem,
    Select,
    Typography
} from '@material-ui/core';
import AnalysisCard from './AnalysisCard';
import ScrollableContainer from '../../../../utility/ScrollableContainer';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { cancelAnalysisAsync, clearAnalysis, setFeatureSelected } from '../../../../../redux/analysis/Actions';
import { Alert, AlertTitle } from '@material-ui/lab';
import SimpleHeading from '../../common/SimpleHeading';


class AnalysisProgress extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        // Redux State
        analysis: PropTypes.object.isRequired,
        // Redux Dispatch
        dispatchCancelAnalysis: PropTypes.func.isRequired,
        dispatchClearAnalysis: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.back = this.back.bind(this);
        this.cancelAnalysis = this.cancelAnalysis.bind(this);
        this.getRemainingTime = this.getRemainingTime.bind(this);
    }

    back () {
        this.props.dispatchClearAnalysis();
    }

    cancelAnalysis () {
        const { analysis, dispatchCancelAnalysis } = this.props;
        dispatchCancelAnalysis(analysis.id);
    }

    getRemainingTime (milliseconds) {
        if (milliseconds < 60000) {
            return `${Math.ceil(milliseconds / 1000)} seconds remaining`;
        } else {
            return `${Math.ceil(milliseconds / 60000)} minutes remaining`;
        }
    }

    // Improve timer so changes based on how big the value
    render () {
        const { classes, analysis } =this.props;

        const progress = Math.floor((analysis.featureAnalyses.length / analysis.total) * 100);

        return (
            <>
                <SimpleHeading
                    label="Result Analysis"
                >
                    {
                        analysis.status === 'running' ? 
                            <Button
                                className={classes.cancelButton}
                                onClick={this.cancelAnalysis}
                            >
                                Cancel
                            </Button>
                        :  <></>
                    }
                    
                </SimpleHeading>
                {/* <div className={classes.flex}> */}
                {/*    */}
                {/*    <Typography color="textPrimary" variant="subtitle1"> */}
                {/*        Result Analysis */}
                {/*    </Typography> */}
                {/*    <Button */}
                {/*        className={classes.cancelButton} */}
                {/*        onClick={analysis.status === 'running' ? this.cancelAnalysis : this.back} */}
                {/*    > */}
                {/*        { analysis.status === 'running' ? 'Cancel' : 'Back' } */}
                {/*    </Button> */}
                {/* </div> */}
                {
                    analysis.status === 'failed' && <Alert icon={false} severity={'error'}>
                        <AlertTitle>
                            Analysis failed to run
                        </AlertTitle>
                        One or more analyses failed to run for the search area
                    </Alert>
                }
                {
                    analysis.status !== 'failed' && <div className={classes.progress}>
                        <div className={classes.flex}>
                            <Typography color="textPrimary" variant="body2">
                                { progress < 100 ? `Analysing: ${progress}% Completed` : '100% Complete' }
                            </Typography>
                            <Typography color="textPrimary" variant="body2">
                                { analysis.status === 'running' && this.getRemainingTime(analysis.remainingTime)}
                            </Typography>
                        </div>
                        <LinearProgress
                            classes={{
                                root: classes.progressRoot,
                                bar: classes.progressBar
                            }}
                            variant="determinate"
                            value={progress}
                        />
                    </div>
                }
            </>
        );
    }
}

const style = theme => ({
    cancelButton: {
        ...theme.typography.caption,
        color: theme.palette.primary.light,
        textTransform: 'initial',
        margin: '-6px -8px',
        justifyContent: 'end',
        minWidth: 0
    },
    flex: {
        display: 'flex',
        alignItems: 'center',
        '& > *:first-child': {
            marginRight: 'auto'
        }
    },
    progress: {
        backgroundColor: `${theme.palette.grey.variant5}1A`,
        padding: '10px',
        '&> *:not(:last-child)':{
            marginBottom: 5
        }
    },
    progressRoot: {
        backgroundColor: 'initial',
        border: `1px solid ${theme.palette.background.border}`,
        height: 10
    },
    progressBar: {
        backgroundColor: theme.palette.primary.light
    }
});

const mapStateToProps = state => {
    return {
        analysis: state.analysis.analysis
    };
};

const mapDispatchToProps = dispatch => ({
    dispatchCancelAnalysis: (id) => dispatch(cancelAnalysisAsync(id)),
    dispatchClearAnalysis: () => dispatch(clearAnalysis())
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(AnalysisProgress);